export class RecipientEntity {
    userIdentityId;
    utronUserId;
    phoneNumber;
    email;
    status;

    constructor(userIdentityId, utronUserId, phoneNumber, email, status) {
        this.userIdentityId = userIdentityId;
        this.utronUserId = utronUserId;
        this.phoneNumber = phoneNumber;
        this.email = email;
        this.status = status;
    }
}